'use strict';
/**
 * @ngdoc function
 * @name thothAppApp.directive:
 * @description
 * # announcements
 * Directive to generate an announcements form
 */
angular.module('thothApp.directives')
.directive('announcements', function() {
  return {
    restrict: 'E',
    scope: {
      projectCode: '=',
      canChat: '=',
      display: '=',
      projectId: '='
    },
    templateUrl: 'views/_announcements.html',
    controller: ['$scope', '$rootScope', '$state', 'Project', '$mdDialog','SessionStorage', '$window', 'toaster',
    'User', '$q', 'Notification',
    function ($scope, $rootScope, $state, Project, $mdDialog, SessionStorage, $window, toaster, User, $q, Notification) {
      const AVAILABLE_CHAR = 500;
      const VALID_KEYS = [37, 38, 39, 40, 18, 91];
      $scope.users = [];
      $scope.showUserList = false;
      $scope.usedChar = 0;
      $scope.isReply = false;
      $scope.availableChar = AVAILABLE_CHAR;
      $scope.$messageBoard = $('#messageBoard');
      $scope.isUserAdmin = $rootScope.userIsAdmin || false;
      $scope.userName = $rootScope.myUser.name || '';
      $scope.activeTab = 'unread';
      $scope.newMessage = { text: '' };
      $scope.updateCharCount = function() {};
      var messagesRef = $rootScope.firebase.database().ref('messages');

      function processMessages(snapshot) {
        $scope.$evalAsync(function() {
            var allMessages = [];
            snapshot.forEach(function(childSnapshot) {
                var message = childSnapshot.val();
                message.$id = childSnapshot.key;
                allMessages.push(message);
            });

            allMessages.reverse();
            $scope.unreadMessages = [];
            $scope.readMessages = [];
            angular.forEach(allMessages, function(message) {
                var userId = $scope.currentUser.sub;
                if (message.readBy && message.readBy[userId]) {
                  $scope.readMessages.push(message);
                } else {
                  $scope.unreadMessages.push(message);
                }
            });
        });
      }

      function listenMessages() {
        messagesRef.off('value', processMessages);
        messagesRef.orderByChild('timestamp').on('value', processMessages);
      }

      $scope.$on('user:login', function(event, user) {
        $scope.currentUser = JSON.parse($window.localStorage.currentUser)
        listenMessages();
      });

      if ($scope.currentUser && ($scope.currentUser.sub)) {
        listenMessages();
      }

      $scope.$on('$destroy', function() {
        messagesRef.off('value', processMessages);
      });

      $scope.currentUser = {
        id: 0
      };

      if ('currentUser' in $window.localStorage) {
        $scope.currentUser = JSON.parse($window.localStorage.currentUser);
        listenMessages();
      }

      $scope.$watch('currentUser', function(newVal, oldVal) {
        if (newVal && newVal.sub !== (oldVal ? oldVal.sub : null)) {
          listenMessages();
        }
      }, true);

      $scope.userInfo = {
        'email': $scope.currentUser.email,
        'name': $scope.currentUser.name,
        'google_id': $scope.currentUser.sub,
      };

      $scope.messageBoardHash = {
        'user': $scope.currenUser,
        'image_src': $scope.currentUser.picture,
        'date': new Date().toLocaleString(),
        'mentioned_users': [],
        'message': '',
        'projectId': $scope.projectId,
      };

      $scope.openReadByModal = function(ev, readers) {
        const readersArray = Object.keys(readers || {}).map(function(key) {
          return readers[key];
        });

        $mdDialog.show({
          controller: $rootScope.readByDialogController,
          templateUrl: 'views/_readByDialog.html',
          targetEvent: ev,
          clickOutsideToClose: true,
          locals: {
            readers: readersArray
          }
        });
      };

      $scope.markAsRead = function(message) {
        var messageId = message.$id;
        var userId = $scope.currentUser.sub;
        var userData = {
            name: $scope.currentUser.name,
            date: new Date().toLocaleString('es-MX', {
              day: 'numeric',
              month: 'numeric',
              year: 'numeric',
              hour: 'numeric',
              minute: '2-digit',
              hour12: true,
            })
        };
        messagesRef.child(messageId).child('readBy').child(userId).set(userData);
      };

      $scope.postFirebaseMessage = function() {
        var messageText = $scope.newMessage.text.trim();
        if (!messageText) return;

        if (!$rootScope.firebase.auth().currentUser) {
          toaster.pop('error', 'Error', 'Sin sesión Firebase. Recarga la página.');
          return;
        }

        var newMessage = {
          user: { name: $scope.currentUser.name, id: $scope.currentUser.sub },
          image_src: $scope.currentUser.picture,
          date: new Date().toLocaleString('es-MX', {
            day: 'numeric',
            month: 'numeric',
            year: 'numeric',
            hour: 'numeric',
            minute: '2-digit',
            hour12: true,
          }),
          message: messageText,
          timestamp: $rootScope.firebase.database.ServerValue.TIMESTAMP
        };

        messagesRef.push(newMessage).then(function() {
          $scope.$evalAsync(function() {
            Notification.sendNotification(newMessage).then(function() {
              toaster.pop('success', 'Éxito', 'Mensaje enviado.');
            }).catch(function(error) {
              console.error('Error al enviar la notificación:', error);
            });
            $scope.newMessage.text = '';
            $("#firebaseMessage").empty();
          });
        }).catch(function(err) {
          console.log(err);
        });
      };

      $scope.getTruncatedReaderList = function(readers) {
        const names = Object.values(readers || {}).map(reader => reader.name);
        if (!names || names.length === 0) {
          return '';
        }

        const maxNamesToShow = 2;
        const totalReaders = names.length;

        if (totalReaders <= maxNamesToShow) {
          return names.join(', ');
        } else {
          const remaining = totalReaders - maxNamesToShow;
          const truncatedNames = names.slice(0, maxNamesToShow).join(', ');
          return `${truncatedNames} y ${remaining} más`;
        }
      };

      function isNameNotInMentionedUsers(user, isReply = false){
        if (user.google_id === $scope.userInfo.google_id && !isReply) {
            toaster.pop('warning', 'Cuidado', 'No te puedes etiquetar a ti mismo en un mensaje.');
            $('#firebaseMessage').html(function(index, oldHtml){
              return oldHtml.replace(/@.+/g, '');
            });
            return false;
        }
        var userList = $scope.messageBoardHash.mentioned_users.filter(function(x) {
            return x.google_id === user.google_id;
        });

        var userInCombinedArray = combinedArray.some(function(x) {
            return x.google_id === user.google_id;
        });

        return userList.length === 0 && userInCombinedArray;
      }

      function updateChars() {
        var usedChars = $("#firebaseMessage").text().length;
        $('#usedChars').text(usedChars);
      }

      function clearMessage() {
        $scope.messageBoardHash.message = "";
        $("#firebaseMessage").empty();
        $scope.messageBoardHash.mentioned_users = [];
        $('#usedChars').text(0);
        $('#messageBoard').animate({ scrollTop: $('#messageBoard').prop('scrollHeight')}, 1500);
      }

      function getUsers(userParams) {
        var deferred = $q.defer();
        User.index(userParams).then(function(response){
          deferred.resolve(response.data.users);
        });

        return deferred.promise;
      }

      function notValidKey(key) {
        for(var l = 0; l < VALID_KEYS.length; l++) {
          if(VALID_KEYS[l] === key) {
            return false;
          }
        }
        return true;
      }

      $( document ).ready(function() {
        if ($scope.canChat) {
          var firebaseMessage = $("#firebaseMessage");
          // remove tags
          firebaseMessage.on('keydown', function(e) {
            var windowSelection = window.getSelection();
            var windowSelectionRange = windowSelection.getRangeAt(0);
            var el = windowSelectionRange.startContainer.parentElement;
            if (event.which === 8) {
              if (el.classList.contains('highlight')) {
                el.remove();
              }
              if (el.classList.contains('yellow-highlight')) {
                var id = '#' + el.id;
                $(id).remove();
              }
            } else if(notValidKey(e.which) && (el.classList.contains('highlight') || el.classList.contains('yellow-highlight'))) {
              // Do nothing if its not backspace and either class is in the way
              event.preventDefault();
            }

            // Do not move from the box, and wait for keyup
            if (event.which === 9) {
              event.preventDefault();
            }
          });

          firebaseMessage.on('keyup', function(e) {
            // Checks if a mentioned user is removed from the input text

            var windowSelection = window.getSelection();
            var windowSelectionRange = windowSelection.getRangeAt(0);
            var el = windowSelectionRange.startContainer.parentElement;
            if(event.which === 8) {
              var indexToDelete = [];
              $scope.messageBoardHash.mentioned_users.map(function(user, index) {
                if(!$("#" + user.id)[0]) {
                  indexToDelete.push(index);
                }
              });
              for(var n = indexToDelete.length - 1; n >= 0; n--) {
                $scope.messageBoardHash.mentioned_users.splice(indexToDelete[n], 1);
              }
            } else if(notValidKey(e.which) && (el.classList.contains('highlight') || el.classList.contains('yellow-highlight'))) {
              var firebaseMessage = $('#firebaseMessage');
              var el1 = firebaseMessage.get(0);
              if(el.classList.contains('highlight')) {
                firebaseMessage.append("&nbsp;");
              }
              if(el.classList.contains('yellow-hightlight')) {
                firebaseMessage.append("<br>");
              }
              focusEndOfString(el1);
              updateChars();
            }
            if (event.which === 8 && $(this).text().length < 1) {
              // Fallback just in case, to remove everything
              $scope.messageBoardHash.mentioned_users = [];
            }
            // Select user using TAB
            if (event.which === 9) {
              if ($scope.users.length > 0) {
                event.preventDefault();
                $scope.selectUser($scope.users[0]);
              } else {
                $scope.showUserList = false;
              }
            } else {
              // Search for users
              var searchQuery = $(e.target).text().match(/@[^\s]+/g);
              if (searchQuery) {
                $scope.showUserList = true;
                searchQuery = searchQuery[0].substr(1);
                var userParams = {
                  'params': {
                    'search': searchQuery
                  }
                };
                getUsers(userParams).then(function(users) {
                  $scope.users = users;
                });
              } else {
                // if no users, stop showing list
                $scope.users = [];
                $scope.showUserList = false;
              }
            }
            updateChars();
          });
        }
      });

      $scope.selectUser = function(user) {
        if(isNameNotInMentionedUsers(user)) {
          editFirebaseMessage(user);
          $scope.users = [];
          $scope.showUserList = false;
        } else {
          toaster.pop('warning', 'Cuidado', 'Este usuario ya esta etiquetado o no se encuentra en el proyecto.');
          $('#firebaseMessage').html(function(index, oldHtml){
            return oldHtml.replace(/@.+/g, '');
          });
          $scope.showUserList = true;
        }
      };

      $scope.replyMessage = function(message){
        if ($scope.canChat) {
          editFirebaseMessage(message, true);
          $scope.isReply = true;
        } else {
          firebase.database().ref($scope.currentUser.id).child(message.$id).remove();
          //Mark clicked message as read with a '✓'.
          if(message.sourceMessageId) {
            var sourceMessage = firebase.database().ref(message.projectId).child(message.sourceMessageId).child('message');
            var pos = message.message.search($scope.userInfo.name) + $scope.userInfo.name.length;
            sourceMessage.set(message.message.substr(0, pos) + '✓' + message.message.substr(pos));
          }
          $state.go('app.projects.show', { projectId: message.projectId });
        }
      };

      function editFirebaseMessage(object, isReply = false) {
        let cleanMessage = "";
        if(object.message) {
          //Remove read chackmarks from reply messages.
          cleanMessage = object.message.replace(/✓/g,'');
        }
        var firebaseMessage = $('#firebaseMessage');
        var el = firebaseMessage.get(0);
        var user = object;
        if('user' in object) {
          user = {
            name: object.user.name,
            google_id: object.user.id,
            email: object.user.email,
            id: object.user.id
          };
        }

        if (isNameNotInMentionedUsers(user, isReply)) {
          firebaseMessage.html(function(index, oldHtml){
            return oldHtml.replace(/@[^\s]+/g, "<span id='" + user.id + "' class='highlight'>" + user.name + "</span>&nbsp;");
          });
          if (isReply) {
            firebaseMessage.prepend("<span id='" + user.id + "' class='highlight'>" + user.name +
            ": <span id='" + user.id + "'class='yellow-highlight'>(" + cleanMessage + ")</span></span><br>&nbsp;");
            $scope.isReply = false;
          }

          $scope.messageBoardHash.mentioned_users.push(user);
          focusEndOfString(el);
          updateChars();
        }
      }

      // Move cursor
      function focusEndOfString(el) {
        var firebaseMessage = $('#firebaseMessage');
        var childNodes = el.childNodes;
        var range = document.createRange();
        var sel = window.getSelection();
        range.setStart(childNodes[childNodes.length - 1], childNodes[childNodes.length - 1].textContent.length);
        range.collapse(true);
        sel.removeAllRanges();
        sel.addRange(range);
        firebaseMessage.focus();
      }

      $scope.sendEmails = function(){
        $scope.currentUser.sendMail = !$scope.currentUser.sendMail;
        $window.localStorage.currentUser = JSON.stringify($scope.currentUser);
      };

      $scope.openManual = function() {
        window.open('https://sites.google.com/scisa.com.mx/guia-completa-intro-sia/inicio', '_blank');
      };

      $scope.openMailbox = function() {
        window.open('https://sugerencias.scisa.com.mx/', '_blank');
      };

      $scope.requestImprovements = function() {
        window.open('https://docs.google.com/forms/d/e/1FAIpQLSdDn_z7bayiOzYZ2WlzOT6d8GUI-4RayJUeOGcw2ozXRqOXOQ/viewform?usp=sharing&ouid=109836533266936852168', '_blank');
      };
    }]
  };
});
